/** Durée en minutes, à la française : 0h, 45 min => 0h45, 90 => 1h30, 1080 => 18h */
export function formatMinutes(minutes: number): string {
  const total = Math.max(0, Math.round(minutes));
  const hours = Math.floor(total / 60);
  const rest = total % 60;

  return rest ? `${hours}h${String(rest).padStart(2, '0')}` : `${hours}h`;
}

